
export interface FootbarConfig {
  mostrarPeso: boolean;
  mostrarVersion: boolean;
  mostrarMascota: boolean;
  mostrarHoraLocal: boolean;
  mostrarUbicacion: boolean;
}


export type NavbarPanel =
  | 'vehiculos'
  | 'alertas'
  | 'geocercas'
  | 'geopuntos'
  | 'historial'
  | 'reportes'
  | 'dashboard'
  | 'auditoria'
  | 'subcuentas'
  | 'conductores'
  | 'eventos'
  | 'multipantalla';

export interface NavbarConfig {
  showpanels: Record<NavbarPanel, boolean>;
  showLogo : boolean
}

interface BaseDisplayConfig {
  displayDefault: string;
}

export interface AlertConfig extends BaseDisplayConfig {}
export interface GeofencesConfig extends BaseDisplayConfig {}
export interface GeopointsConfig {
  showPoint: boolean;
  showLabel: boolean;
}
export interface EventsConfig {
  eventDefaults: Record<string, string>;   // estados dinámicos, ej: { "ON": "Transmitting" }
  vehicleDefaults: Record<string, string>; // estados dinámicos, ej: { "OFF": "Idle" }
}


// CONFIGURACION DE VEHICULOS
export interface VehicleConfig {
  display: {
    showOnMap: boolean;
    showByOperation: boolean;
    showOnlyVisible: boolean;
  };
 transmissions: Record<string, boolean>,
 panelOptions : VehiclePanelOption[]
}

export interface VehicleDisplay {
  showOnMap: {
    enabled: boolean;          // true = marcado/activado
    visible: boolean;          // true = se muestra, false = se oculta
  };
  showByOperation: {
    enabled: boolean;          // true = marcado/activado
    visible: boolean;          // true = se muestra, false = se oculta
  };
  showOnlyVisible: {
    enabled: boolean;          // true = marcado/activado
    visible: boolean;          // true = se muestra, false = se oculta
  };
}
export interface VehiclePanelOption {
  [id : string] : {
    id: string;                // idItem
    variant: string;           // variant
    enabled: boolean;          // true = marcado/activado
    visible: boolean;          // true = se muestra, false = se oculta
  }
}

export interface showVehicleButton {
  selected : number,
  showOptions : boolean
}

export enum ConfigKeys {
  THEME = "theme-config",
  NAVBAR = "navbar-config",
  ALERT = "alert-config",
  DRIVER = "driver-config",
  EVENT = "event-config",
  GEOFENCE = "geofence-config",
  GEOPOINT = "geopoint-config",
  VEHICLE = "vehicle-config",
  HISTORY = "history-config",
  HISTORY_DRAWER = "history-drawer-config",
  VEHICLE_CARD = "vehicle-card-config", // lo gestion user card vehicle
}
